import { render, staticRenderFns } from "./StudentCourses.vue?vue&type=template&id=6adf558f"
import script from "./StudentCourses.vue?vue&type=script&lang=ts"
export * from "./StudentCourses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports